'use client';

import { ReactNode } from 'react';

export const PageContentWrapper = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};

